import { PipeTransform, Pipe } from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'moment'})
export class MomentPipe implements PipeTransform {
    transform(value, format: string = 'DD-MM-YYYY @ hh:mm') : any {
        return value ? moment(value).format(format) : 'n/a';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/pipes/moment.pipe.ts